import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../slice/user';
import modalReducer from '../slice/modal';
import territoryCheckReducer from '../slice/territoryCheck';

export const store = configureStore({
  reducer: {
    user: userReducer,
    modal: modalReducer,
    territoryCheck: territoryCheckReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
